import * as React from 'react';
import { Form, Utils } from 'lexisnexis-form';
import _ from 'lodash-es';
import { applicationHeartbeat } from '../../Application/redux-objects/actions';
import * as urls from '../../shared/urls';
import { createFormUrl, getForm } from '../../../services/formIOService';
import VINComponent from '../VinLookup/lib/VinLookupComponent';
import DriversLicenseComponent from '../DriversLicenseLookup/lib/DriversLicenseLookupComponent';
import LicensePlateLookupComponent from '../LicensePlateLookup/lib/LicensePlateLookupComponent';
import AutoCompleteComponent from '../AutoComplete/lib/AutoCompleteComponent';
import AreaOfDamage from '../AreaOfDamage/lib/AreaOfDamage';
import MapComponent from '../MappingComponent/lib/MapComponent';
import { applyFormSchemaFixes } from './FormSchemaFixes';

const LexisNexisForm: any = require('lexisnexis-form');
const ComponentsRegistry = LexisNexisForm && LexisNexisForm.Components;

if (ComponentsRegistry && ComponentsRegistry.addComponent) {
  ComponentsRegistry.addComponent('mapComponent', MapComponent);
  ComponentsRegistry.addComponent('vinLookup', VINComponent);
  ComponentsRegistry.addComponent('driversLicenseLookup', DriversLicenseComponent);
  ComponentsRegistry.addComponent('licensePlateLookup', LicensePlateLookupComponent);
  ComponentsRegistry.addComponent('AutoCompleteComponent', AutoCompleteComponent);
  ComponentsRegistry.addComponent('areasOfDamage', AreaOfDamage);
}

export interface IFormProps {
  formId: string;
  data?: any;
  onChange?: (formData: any, isValid?: boolean) => void;
  readOnly?: boolean;
  onRender?: () => void;
  handleValidation?: boolean;
  setFormErrors?: (errors: Array<any>) => void;
}

interface IFormLocalState {
  layout: any;
  hasErrorsOrWarnings: boolean;
  hasErrors: boolean;
  hasValidated: boolean;
  handleValidation: boolean;
  formErrors: Array<any>;
}

function everyComponent(components, fn) {
  return _.each(components, (component, index) => {
    if (fn(component, components, index) === false) {
      return false;
    }

    if (typeof component.everyComponent === 'function') {
      if (component.everyComponent(fn, true) === false) {
        return false;
      }
    }

    return true;
  });
}

export default class FormIO extends React.Component<
  IFormProps,
  IFormLocalState
> {
  form: any;
  errorMessage;
  validation;
  instance;
  handleChange;
  heartBeatInterval;
  formUrl: string;

  constructor(props) {
    super(props);
    this.state = {
      layout: null,
      hasErrorsOrWarnings: false,
      hasErrors: false,
      hasValidated: false,
      handleValidation: this.props.handleValidation || true,
      formErrors: null,
    };

    this.handleChange = _.debounce(this._handleChange.bind(this), 200);
    this.errorMessage = 'There are some validation errors.';
    this.validation = [];
    this.formUrl = createFormUrl(this.props.formId);

    getForm(this.props.formId).then(data =>
      this.setState({ layout: applyFormSchemaFixes(data) })
    );
  }

  getSubmission() {
    const submission = _.cloneDeep(this.form.formio.submission);

    return submission;
  }

  setSubmission(submission: any) {
    if (this.form && this.form.formio && this.form.formio.setSubmission) {
      // Imperatively push the new submission into the live FormIO instance so the
      // rendered fields update (the submission prop is only applied on initial mount).
      this.form.formio.setSubmission(_.cloneDeep(submission));
    }
  }

  getValidationErrors = (displayErrorMessage = true) => {
    if (!this.form || !this.form.formio) {
      return [];
    }

    return this.validate(this.form.formio.submission, displayErrorMessage) || [];
  };

  _handleChange = () => {
    if (!this.form || this.form.formio == undefined) {
      return;
    }

    if (!this.heartBeatInterval) {
      this.heartBeatInterval = setInterval(() => {
        applicationHeartbeat(urls.HEART_BEAT);
      }, 10000);
    }

    const { submission } = this.form.formio;

    const validationErrors = this.validate(submission, true) || [];
    const isValid = !validationErrors.some((message) => message.type === 'error');

    if (this.props.onChange) {
      this.props.onChange(submission, isValid);
    }
  };

  setValidation(form) {
    if (this.state.handleValidation) {
      if (form.type === 'form') {
        this.validation = Utils.ValidationService.translateValidationToJsonLogic(
          _.get(form, 'properties.validation', this.validation)
        );
        Utils.validation = this.validation;
      }

      const { formio } = this.form;
      formio.setPristine(false);

      if (!_.isEqual(formio.submission, {})) {
        formio.setErrors([]);
      }

      this.validate(formio.submission, true);

      // if (!_.isEqual(formio.submission, {})) {
      //   formio.setErrors([]);
      // }

      formio.validate = this.validate.bind(this);
    }
  }

  logData = () => {
    console.log(this.form.formio.submission);
  };

  validate(submission: any = {}, displayErrorMessage = false) {
    const data = submission?.data || {};
    const result = Utils.ValidationService.validate(this.validation, data);
    const resultArray = (Array.isArray(result) ? result : []).map((error) => {
      const normalizedError = { ...error };
      const fallbackComponents = Array.isArray(normalizedError.paths)
        ? normalizedError.paths
        : [];

      normalizedError.components = Array.isArray(normalizedError.components)
        ? normalizedError.components
        : fallbackComponents;

      normalizedError.paths = Array.isArray(normalizedError.paths)
        ? normalizedError.paths
        : [];

      normalizedError.errorPaths = Array.isArray(normalizedError.errorPaths)
        ? normalizedError.errorPaths
        : [];

      return normalizedError;
    });
    const { formio } = this.form;

    if (formio.everyComponent) {
      formio.everyComponent(component => {
        const message = component.getTranscriptionLookupError
          ? component.getTranscriptionLookupError()
          : null;
        if (message) {
          resultArray.push({ type: 'error', message, components: [], paths: [], errorPaths: [] });
        }
      });
    }

    if (formio.setErrors) {
      // && result.length > 0
      formio.setErrors(resultArray);
    }

    const getComponent = (error) => {
      const [path = ''] = Array.isArray(error.components) ? error.components : [];
      const errorPaths = Array.isArray(error.errorPaths) && Array.isArray(error.errorPaths[0])
        ? error.errorPaths[0]
        : [];
      const key = path && path.includes('.')
        ? path.slice(path.lastIndexOf('.') + 1)
        : path;

      let rowComponent = null;
      errorPaths.forEach((path, i) => {
        if (path && !_.isNil(path.index)) {
          const container =
            (rowComponent || formio).getComponent(path.key) || rowComponent;

          if (
            container &&
            container.component.type === 'editgrid' &&
            container.editRows[path.index]
          ) {
            rowComponent = container
              .getComponents(path.index)
              .reduce((acc, comp) => {
                if (comp && comp.getComponent) {
                  const searchKey =
                    i < errorPaths.length - 1 ? errorPaths[i + 1].key : key;
                  acc = comp.getComponent(searchKey) || acc;
                }
                return acc;
              }, null);
          }
        }
      });

      if (!errorPaths.length && !rowComponent) {
        rowComponent = formio.getComponent(key);
      }

      return rowComponent;
    };

    const originalErrors = Array.isArray(formio.validationErrors)
      ? _.cloneDeep(formio.validationErrors)
      : [];
    const validationErrors = Array.isArray(formio.validationErrors)
      ? formio.validationErrors
      : [];
    formio.validationErrors = validationErrors.reduce((acc, error) => {
      if (!error.section) {
        const component = getComponent(error);
        let sectionErrorsAdded = false;

        if (component) {
          const getSection = (comp) => {
            if (comp && comp.component && comp.component.type === 'section') {
              return comp;
            }

            if (comp && comp.parent) {
              return getSection(comp.parent);
            }
          };

          const section = getSection(component);
          if (section && section.validationErrors) {
            const errors = section.validationErrors;
            errors.forEach((errorItem) => {
              if (!originalErrors.some((err) => _.isEqual(err, errorItem))) {
                acc.push(errorItem);
                sectionErrorsAdded = true;
              }
            });
          }
        }

        if (!sectionErrorsAdded) {
          acc.push(error);
        }
      } else {
        acc.push(error);
      }
      return acc;
    }, []);

    const nowHasErrorsOrWarnings =
      resultArray.length > 0;

    const nowHasErrors =
      resultArray.length > 0 &&
      resultArray.some((x) => x.type == 'error');

    if (
      this.state.hasErrorsOrWarnings != nowHasErrorsOrWarnings ||
      this.state.hasErrors != nowHasErrors
    ) {
      this.setState({
        hasErrorsOrWarnings: nowHasErrorsOrWarnings,
        hasErrors: nowHasErrors,
      });
    }

    if (this.props.setFormErrors) {
      const errors = resultArray.filter(r => r.type == 'error');
      if (errors && !_.isEqual(this.state.formErrors, errors)) {
        this.setState({
          formErrors: errors
        })
        this.props.setFormErrors(errors);
      }
    }

    this.highlightFields();
    if (displayErrorMessage) {
      //  && result.length > 0)
      const globalErrors = resultArray
        ? resultArray.filter((error) => Array.isArray(error.paths) && error.paths.length === 0)
        : [];
      formio.customErrors =
        resultArray.length > 0 ? [this.errorMessage].concat(globalErrors) : [];
      formio.showErrors([], true);
    }

    formio.emit('validationFinished');

    return resultArray;
  }

  getComponentComponents(component, [selector, ...rest], prevSelector = {}) {
    let result = null;
    const { path } = selector;
    const { index } = prevSelector as any;
    const { type } = component.component;
    const isDataGrid = type === 'datagrid';
    const isEditGrid = type === 'editgrid';
    const isGrid = (isDataGrid || isEditGrid) && !_.isNil(index);
    const components = !isGrid
      ? component.components
      : isDataGrid
        ? component.rows[index]
        : component.editRows[index]
          ? component.editRows[index].components
          : [];

    everyComponent(components, (comp) => {
      if (comp.component.key === path) {
        result =
          rest.length > 0 && comp.everyComponent
            ? this.getComponentComponents(comp, rest as any, selector)
            : comp;

        return false;
      }

      return true;
    });

    return result;
  }

  getComponents(selector) {
    return _.compact([this.getComponentComponents(this.form.formio, selector)]);
  }

  handleError = (errors) => {
    const error = errors && errors.length > 0 ? errors[0].message : '';
    // Removing this since this is already a part of the validate method
    /*if ((errors && errors.length > 0) != this.state.hasErrorsOrWarnings)
      this.setState({
        hasErrorsOrWarnings: errors && errors.length > 0,
        hasErrors:
          errors && errors.length > 0 && errors.some((x) => x.type == 'error'),
      }); */
    //console.log('Submission status: ' + error);
  };

  highlightFields() {
    const { validationErrors } = this.form.formio;

    const componentErrors = [];
    if (Array.isArray(validationErrors)) {
      validationErrors.forEach((error) =>
        (Array.isArray(error.paths) ? error.paths : []).forEach((path) =>
          this.getComponents(path).forEach((component) => {
            const isWarning = error.type === 'warning';
            component.setCustomValidity(error.message, true, true, isWarning);
            componentErrors.push(component.id);
          })
        )
      );
    }
    // Clear any components without errors.
    this.form.formio.everyComponent((component) => {
      if (!componentErrors.includes(component.id)) {
        component.setCustomValidity('', true, true);
      }
    });
  }

  customValidation(submission, callback) {
    if (!this.form) {
      callback(null);
      return;
    }

    const result = this.validate(submission);
    callback(
      result.some((message) => message.type === 'error')
        ? this.errorMessage
        : null
    );
  }

  setValue(submission, flags = {}, ignoreEstablishment) {
    this.form.instance._submission = submission;
    if (flags
      //&& flags.fromSubmission 
      && (this.form.instance.options.readOnly || this.form.instance.editMode) && !this.form.instance.isHtmlRenderMode()) {
      this.form.instance._data = submission.data;
    }
    // if (!ignoreEstablishment) {
    //   this.form.instance.establishPages(submission.data);
    // }
    const changed = this.getPages({ all: true }).reduce((changed, page) => {
      return this.setNestedValue(page, submission.data, flags) || changed;
    }, false);
    // if (changed) {
    //   this.form.instance.pageFieldLogic(this.form.instance.page);
    // }
    // this.form.instance.setEditMode(submission);
    return changed;
  }

  setNestedValue(component, value, flags: any = {}) {
    component._data = this.componentContext();
    if (component.type === 'button') {
      return false;
    }
    if (component.type === 'components') {
      return component.setValue(value, flags);
    }
    else if (value && component.hasValue(value)) {
      return component.setValue(_.get(value, component.key), flags);
    }
    else if ((!this.form.instance.rootPristine || component.visible) && component.shouldAddDefaultValue) {
      flags.noValidate = !flags.dirty;
      flags.resetValue = true;
      return component.setValue(component.defaultValue, flags);
    }
  }

  getPages(args: any = {}) {
    const { all = false } = args;
    const pages = this.form.instance.hasExtraPages ? this.form.instance.components : this.form.instance.pages;
    const seenPages = Array.isArray(this.form.instance._seenPages)
      ? this.form.instance._seenPages
      : [];
    const filteredPages = pages
      .filter(all ? _.identity : (p, index) => seenPages.includes(index));

    return filteredPages;
  }

  componentContext() {
    return this.form.instance._data;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  isValid = () => {
    const result = this.getValidationErrors(false);
    return !result.some((message) => message.type === 'error');
  };

  componentWillUnmount() {
    this.heartBeatInterval = null;
  }

  render() {
    return (
      <React.Fragment>
        {this.state.layout != null && (
          <Form
            url={this.formUrl}
            form={this.state.layout}
            submission={this.props.data}
            onChange={() => {
              this.handleChange();
            }}
            onError={this.handleError}
            options={{
              hooks: {
                customValidation: (...args) =>
                  this.customValidation(args[0], args[1]),
              },
              readOnly: this.props.readOnly ? this.props.readOnly : false,
              noAlerts: true,
              componentErrorClass: 'alert alert-danger',
              componentWarningClass: 'alert alert-warning',
            }}
            ref={(instance) => {
              if (instance) {
                instance.createPromise.then(() => {
                  const { wizard } = instance.formio;
                  if (wizard) {
                    this.instance = instance.formio;
                    this.form = instance;
                    this.setValidation(wizard);
                  }

                });
              }
            }}
            onRender={() =>
              this.props.onRender ? this.props.onRender() : true
            }
          />
        )}

        {this.state.layout == null && <div>Loading Form....</div>}
      </React.Fragment>
    );
  }
}
